import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const FAQS = [
  {
    q: "How does Your Helper work?",
    a: "Post a job describing what you need, with photos and your budget. Local taskers send you offers, and you compare profiles, ratings and reviews before choosing who to book. Chat in the app, get the job done, and pay securely when it's complete.",
  },
  {
    q: "How much does it cost to post a job?",
    a: "Posting a job is completely free, and you agree the price with your tasker before any work begins. When a job is completed we add a small service fee for customers, and taskers pay a service fee on their earnings — every charge is shown clearly before you confirm, so there are never hidden costs.",
  },
  {
    q: "How are taskers verified?",
    a: "Taskers can verify their identity through our verification system, and every profile shows ratings and reviews from previous customers so you can choose with confidence.",
  },
  {
    q: "How do payments work?",
    a: "Payments are handled securely through our payment provider — you never need to hand over cash or share bank details with a tasker.",
  },
  {
    q: "Where is Your Helper available?",
    a: "We're live across London — from Camden to Clapham — and expanding to more UK cities soon. Check our London page for the full list of covered areas.",
  },
  {
    q: "Do I need the app to use Your Helper?",
    a: "Yes — the app is where everything happens: posting jobs, receiving offers, chatting and paying securely. It's free on the App Store and Google Play.",
  },
];

export default function FAQ() {
  return (
    <section id="help" data-testid="faq-section" className="py-20 md:py-28 bg-white">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <Eyebrow>Help & FAQ</Eyebrow>
          <h2 className="mt-4 font-display font-extrabold tracking-tight text-navy text-3xl sm:text-4xl lg:text-5xl">
            Questions, answered.
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-slate-200">
                <AccordionTrigger
                  data-testid={`faq-question-${i + 1}`}
                  className="font-display font-bold text-navy text-base sm:text-lg py-6 hover:no-underline hover:text-teal transition-colors duration-200"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-answer-${i + 1}`}
                  className="text-sm sm:text-base text-slate-600 leading-relaxed pb-6"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
